import Translator, { __ } from "services/Translator";

//Auth module
import PrivateRoute from "routes/PrivateRoute";
import OpenRoute from "routes/OpenRoute";
import ChatRoute from "routes/ChatRoute";

// import external modules
import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import Spinner from "components/Spinner";

import Landing from "pages/Landing";
import SignUp from "pages/Landing";
import LangFixer from "pages/LangFixer";
import Chat from "components/Chat";

const WelcomePromotions = lazy(() => import("pages/WelcomePromotions"));
const SlotsPromotions = lazy(() => import("pages/SlotsPromotions"));
const PokerPromotiops = lazy(() => import("pages/PokerPromotiops"));
const SportsbookPromotions = lazy(() => import("pages/SportsbookPromotions"));
const BingoLanding = lazy(() => import("pages/BingoLanding"));
const PokerLanding = lazy(() => import("pages/PokerLanding"));
const SportsLanding = lazy(() => import("pages/SportsLanding"));
const Error = lazy(() => import("pages/Error"));
const Promotions = lazy(() => import("pages/Promotions"));
const Games = lazy(() => import("pages/Games"));
const GamePlay = lazy(() => import("pages/GamePlay"));
const FaqPage = lazy(() => import("pages/FaqPage"));
const VipClub = lazy(() => import("pages/VIP/VIPClub"));
const UserDashboard = lazy(() => import("pages/UserDashboard"));
const Terms = lazy(() => import("pages/Terms"));
const Privacy = lazy(() => import("pages/Privacy"));
const AMLPolicy = lazy(() => import("pages/AMLPolicy"));
const BonusTerms = lazy(() => import("pages/BonusTerms"));
const Races = lazy(() => import("pages/Races"));
const Rewards = lazy(() => import("pages/Rewards"));
const Login = lazy(() => import("pages/auth/Login"));
const Register = lazy(() => import("pages/auth/Register"));
const RecoverPassword = lazy(() => import("pages/auth/RecoverPassword"));
const ResetPassword = lazy(() => import("pages/auth/ResetPassword"));
const ResendActivation = lazy(() => import("pages/auth/ResendActivation"));
const Blogs = lazy(() => import("pages/Blogs"));
const BlogDetails = lazy(() => import("pages/BlogDetails"));
const Bitcoin = lazy(() => import("pages/Bitcoin"));
const Affiliate = lazy(() => import("pages/Affiliates"));
const Stores = lazy(() => import("pages/Stores"));
const Tickets = lazy(() => import("pages/Tickets"));
const TicketDetails = lazy(() => import("pages/TicketDetails"));
const InteracResult = lazy(() => import("pages/InteracResult"));

function OpenRoutes() {
  return (
    <BrowserRouter basename={"/" + Translator.getSelectedLanguage().code + "/"}>
      <Suspense fallback={<Spinner />}>
        <Switch>
          <OpenRoute exact path={"/"} component={Landing}></OpenRoute>

        <OpenRoute
          exact
          path={"/welcome-promotions"}
          component={WelcomePromotions}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/slots-promotions"}
          component={SlotsPromotions}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/poker-promotions"}
          component={PokerPromotiops}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/sportsbook-promorions"}
          component={SportsbookPromotions}
        ></OpenRoute>

        <OpenRoute
          exact
          path={"/account-activated"}
          component={Landing}
        ></OpenRoute>
        <OpenRoute exact path={"/bingo"} component={BingoLanding}></OpenRoute>
        <OpenRoute exact path={"/poker"} component={PokerLanding}></OpenRoute>
        <OpenRoute
          exact
          path={"/sports-betting"}
          component={SportsLanding}
        ></OpenRoute>
        <OpenRoute exact path={"/error"} component={Error}></OpenRoute>
        <OpenRoute exact path={"/vip"} component={VipClub}></OpenRoute>
        <OpenRoute exact path={"/rewards"} component={Rewards}></OpenRoute>
          <OpenRoute exact path={"/faqs"} component={FaqPage}></OpenRoute>
          <OpenRoute exact path={"/faq"} component={FaqPage}></OpenRoute>
        <OpenRoute
          exact
          path={"/promotions"}
          component={Promotions}
        ></OpenRoute>
        <OpenRoute exact path={"/bitcoin"} component={Bitcoin}></OpenRoute>
        <OpenRoute exact path={"/signup"} component={SignUp}></OpenRoute>
          <OpenRoute exact path={"/terms"} component={Terms}></OpenRoute>
          <OpenRoute
            exact
            path={"/terms-and-conditions"}
            component={Terms}
          ></OpenRoute>
        <OpenRoute exact path={"/bonus-terms"} component={BonusTerms}></OpenRoute>
          <OpenRoute exact path={"/privacy"} component={Privacy}></OpenRoute>
          <OpenRoute exact path={"/privacy-policy"} component={Privacy}></OpenRoute>
        <OpenRoute exact path={"/aml-policy"} component={AMLPolicy}></OpenRoute>
        <OpenRoute exact path={"/legal"} component={Terms}></OpenRoute>
        <OpenRoute exact path={"/affiliates"} component={Affiliate}></OpenRoute>
        <OpenRoute exact path={"/vip-program"} component={VipClub}></OpenRoute>
        <OpenRoute
          exact
          path={"/games/:category"}
          component={Games}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/play/:slug/:mode?"}
          component={GamePlay}
        ></OpenRoute>
        {/* auth pages */}
        <OpenRoute
          exact
          path={"/reset-password/:userId/:code"}
          component={ResetPassword}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/resend-activation"}
          component={ResendActivation}
        ></OpenRoute>

        <OpenRoute exact path={"/login"} component={Login}></OpenRoute>
        <OpenRoute exact path={"/register"} component={Register}></OpenRoute>
        <OpenRoute
          exact
          path={"/recover-password"}
          component={RecoverPassword}
        ></OpenRoute>
        <Redirect exact from={"/profile"} to={"/login"} />
        <Redirect exact from={"/gameplay-history"} to={"/login"} />
        <Redirect exact from={"/history"} to={"/login"} />
        <Redirect exact from={"/account-activity"} to={"/login"} />
        <Redirect exact from={"/responsible-gaming-settings"} to={"/login"} />
        <Redirect exact from={"/account-verification"} to={"/login"} />
        <Redirect exact from={"/messages"} to={"/login"} />

        <OpenRoute exact path={"/races"} component={Races}></OpenRoute>
        <OpenRoute exact path={"/blogs"} component={Blogs}></OpenRoute>
        <OpenRoute
          exact
          path={"/blog-details/:slug"}
          component={BlogDetails}
        ></OpenRoute>
        <OpenRoute
          exact
          path={"/interac-result/:res"}
          component={InteracResult}
        />
          <OpenRoute path="*" component={LangFixer} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}

class PrivateRoutes extends Component {
  render() {
    return (
      <BrowserRouter
        basename={"/" + Translator.getSelectedLanguage().code + "/"}
      >
        <Suspense fallback={<Spinner />}>
          <Switch>
            <PrivateRoute exact path="/" component={Landing}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/bitcoin"}
            component={Bitcoin}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/games/:category"}
            component={Games}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/play/:slug/:mode?"}
            component={GamePlay}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/dashboard/:tab?"}
            component={UserDashboard}
          ></PrivateRoute>
          <Redirect
            exact
            from={"/profile"}
            to={"/dashboard/account-details"}
          />
          <Redirect
            exact
            from={"/gameplay-history"}
            to={"/dashboard/gaming-history"}
          />
          <Redirect
            exact
            from={"/history"}
            to={"/dashboard/transaction-history"}
          />
          <Redirect
            exact
            from={"/account-activity"}
            to={"/dashboard/account-activity"}
          />
          <Redirect
            exact
            from={"/responsible-gaming-settings"}
            to={"/dashboard/responsible-gaming"}
          />
          <Redirect
            exact
            from={"/account-verification"}
            to={"/dashboard/verify"}
          />
          <Redirect
            exact
            from={"/messages"}
            to={"/dashboard/messages"}
          />

          <PrivateRoute
            exact
            path={"/promotions"}
            component={Promotions}
          ></PrivateRoute>

          <PrivateRoute exact path={"/vip"} component={VipClub}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/rewards"}
            component={Rewards}
          ></PrivateRoute>
            <PrivateRoute exact path={"/faqs"} component={FaqPage}></PrivateRoute>
            <PrivateRoute exact path={"/faq"} component={FaqPage}></PrivateRoute>
          <PrivateRoute exact path={"/terms"} component={Terms}></PrivateRoute>
            <PrivateRoute
              exact
              path={"/terms-and-conditions"}
              component={Terms}
            ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/bonus-terms"}
            component={BonusTerms}
          ></PrivateRoute>
            <PrivateRoute exact path={"/privacy"} component={Privacy}></PrivateRoute>
            <PrivateRoute
              exact
              path={"/privacy-policy"}
              component={Privacy}
            ></PrivateRoute>
          <PrivateRoute
            exact
            path={"/aml-policy"}
            component={AMLPolicy}
          ></PrivateRoute>
          <PrivateRoute exact path={"/legal"} component={Terms}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/vip-program"}
            component={VipClub}
          ></PrivateRoute>
          <ChatRoute exact path="/chat" component={Chat}></ChatRoute>
          <PrivateRoute exact path={"/races"} component={Races}></PrivateRoute>

          <PrivateRoute exact path={"/blogs"} component={Blogs}></PrivateRoute>
          <PrivateRoute
            exact
            path={"/blog-details/:slug"}
            component={BlogDetails}
          ></PrivateRoute>

          <PrivateRoute exact path={"/store"} component={Stores}></PrivateRoute>

          <PrivateRoute exact path={"/tickets"} component={Tickets} />
          <PrivateRoute
            exact
            path={"/ticket-details/:id"}
            component={TicketDetails}
          />
          <PrivateRoute
            exact
            path={"/interac-result/:res"}
            component={InteracResult}
          />
          <PrivateRoute
            exact
            path={"/affiliates"}
            component={Affiliate}
          ></PrivateRoute>
            <PrivateRoute path="*" component={LangFixer} />
          </Switch>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export { OpenRoutes, PrivateRoutes };
